import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=1f071b81&scoped=true"
import script from "./CardSlider.vue?vue&type=script&lang=js"
export * from "./CardSlider.vue?vue&type=script&lang=js"
import style0 from "./CardSlider.vue?vue&type=style&index=0&id=1f071b81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f071b81",
  null
  
)

export default component.exports